"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paymentSummary = exports.payNothingIcon = exports.payNothingItem = exports.payments = exports.mask = exports.label = exports.iconButton = exports.icon = exports.description = exports.nothingToPay = exports.amount = exports.paymentSchedule = void 0;

var _react = require("@emotion/react");

var _polished = require("polished");

var _legacy = require("../../../components/legacy");

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 24px 0;\n  font-size: 100%;\n  font-weight: ", ";\n  letter-spacing: -0.3px;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: -21px;\n  height: 20px;\n  width: auto;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  list-style-type: none;\n  margin: 0;\n  padding: 0 0 0 16px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 7px;\n    right: 0;\n    .css-", " > & {\n      right: 30%;\n    }\n    border-radius: 2px;\n    margin: 3px 0;\n    background: linear-gradient(\n      90deg,\n      ", " 0%,\n      ", " 128.58%\n    );\n    z-index: 1;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  &::before {\n    content: '';\n    display: inline-block;\n    height: 3px;\n    width: 3px;\n    border-radius: 50%;\n    margin: 0 4px;\n    background-color: ", ";\n    transform: translateY(-100%);\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  padding: 0 4px;\n  cursor: pointer;\n  vertical-align: middle;\n  color: ", ";\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  height: 16px;\n  width: auto;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  margin: 0;\n\n  li:not(:last-of-type) > & {\n    margin: 0 0 24px 0;\n  }\n\n  & > *:first-of-type {\n    margin: 0 0 0 7px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  list-style-type: none;\n  font-weight: ", ";\n\n  & > span {\n    margin: 0 0 0 7px;\n  }\n\n  li:not(:last-of-type) &::after {\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  list-style-type: none;\n  ", ";\n  font-weight: ", ";\n\n  & > span {\n    margin: 0 0 0 7px;\n  }\n\n  ", "\n\n  li:not(:last-of-type)", "\n    > &::after {\n    ", "\n  }\n\n  ", " > &::after {\n    ", "\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 8px;\n  padding: 16px 20px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  content: '';\n  position: absolute;\n  top: ", ";\n  left: -11px;\n  display: inline-block;\n  height: ", ";\n  width: 68px;\n  background: ", ";\n  transform: rotate(90deg);\n  transform-origin: center left;\n  z-index: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var line = function line(_ref) {
  var colors = _ref.colors,
      fade = _ref.fade,
      isInstalment = _ref.isInstalment,
      _ref$hasPayNothingTod = _ref.hasPayNothingToday,
      hasPayNothingToday = _ref$hasPayNothingTod === void 0 ? false : _ref$hasPayNothingTod;
  return (0, _react.css)(_templateObject(), hasPayNothingToday ? "".concat(isInstalment ? '100%' : '83%') : '50%', isInstalment ? '1px' : '2px', fade ? "linear-gradient(to right, ".concat(colors.neutral[300], ", transparent) ") : colors.neutral[300]);
};

var paymentSchedule = (0, _react.css)(_templateObject2());
exports.paymentSchedule = paymentSchedule;

var amount = function amount(leadingPayments, isLoading, isTruncated, instalmentNumber) {
  return function (_ref2) {
    var colors = _ref2.colors,
        fontWeights = _ref2.fontWeights;
    return (0, _react.css)(_templateObject3(), isLoading && "color: ".concat(colors.neutral[300]), fontWeights.medium, instalmentNumber >= 0 ? "&::before {\n      position: absolute;\n      left: -15px;\n      content: '".concat(instalmentNumber + 1, "';\n      font-size: 13px;\n      width: 16px;\n      vertical-align: middle;\n      z-index: 1;\n      background-color: ").concat(colors.neutral[0], ";\n      color: ").concat(instalmentNumber > 0 ? (0, _polished.rgba)(colors.neutral[600], 0.5) : 'inherit', ";\n    }") : "&::before {\n    position: absolute;\n    left: -19px;\n    content: '\\2022';\n    font-size: 30px;\n    width: 16px;\n    vertical-align: middle;\n    text-align: center;\n    z-index: 1;\n    color: ".concat(isLoading ? colors.neutral[300] : 'inherit', ";\n  }"), isTruncated && ":nth-of-type(-n + ".concat(leadingPayments - 1, ")"), line({
      colors: colors,
      fade: false,
      isInstalment: instalmentNumber >= 0
    }), isTruncated && leadingPayments && leadingPayments > 1 && "li:nth-of-type(".concat(leadingPayments, ")"), line({
      colors: colors,
      fade: true,
      isInstalment: instalmentNumber >= 0
    }));
  };
};

exports.amount = amount;

var nothingToPay = function nothingToPay(isInstallment) {
  return function (_ref3) {
    var colors = _ref3.colors,
        fontWeights = _ref3.fontWeights;
    return (0, _react.css)(_templateObject4(), fontWeights.medium, line({
      colors: colors,
      fade: false,
      isInstalment: isInstallment,
      hasPayNothingToday: true
    }));
  };
};

exports.nothingToPay = nothingToPay;
var description = (0, _react.css)(_templateObject5());
exports.description = description;
var icon = (0, _react.css)(_templateObject6());
exports.icon = icon;

var iconButton = function iconButton(_ref4) {
  var colors = _ref4.colors;
  return (0, _react.css)(_templateObject7(), colors.neutral[600]);
};

exports.iconButton = iconButton;

var label = function label(_ref5) {
  var colors = _ref5.colors;
  return (0, _react.css)(_templateObject8(), colors.neutral[500]);
};

exports.label = label;

var mask = function mask(_ref6) {
  var colors = _ref6.colors;
  return (0, _react.css)(_templateObject9(), description.name, colors.neutral[200], (0, _legacy.hexRgb)(colors.neutral[200], 0));
};

exports.mask = mask;
var payments = (0, _react.css)(_templateObject10());
exports.payments = payments;
var payNothingItem = (0, _react.css)(_templateObject11());
exports.payNothingItem = payNothingItem;
var payNothingIcon = (0, _react.css)(_templateObject12());
exports.payNothingIcon = payNothingIcon;

var paymentSummary = function paymentSummary(_ref7) {
  var fontWeights = _ref7.fontWeights;
  return (0, _react.css)(_templateObject13(), fontWeights.normal);
};

exports.paymentSummary = paymentSummary;